<template>
  <div v-if="uploadFile">
      <div class="row">
        <div class="col-4">
          <label class="file_upload my-3">
            <upload fillColor="#009FE3" class="choose_file" :size=Number(40) />
            <b-form-file
                v-model="file_upload"
                :accept="file_type"
                name="file_upload"
                class="file_upload_input"
                :state="Boolean(file_upload)"
                @change.prevent="addDataSource"
            ></b-form-file>
          </label>
        </div>
        <div class="col-8">
          <search
              :placeholder="'Search files'"
              :clickHandler="searchFiles"
          ></search>
        </div>
      </div>
      <hr>
      <div :class="rootClass">
        <ul :class="`${rootClass}__wrapper`" v-if="dataImagesLocal.length > 0">
          <li v-for="(dataImage, index) in dataImagesLocal" :key="index" :class="`${rootClass}__item`">
            <div
                :title="assetListItemTitle(dataImage)"
                :class="classThumbnail(singleSelected.id, dataImage.id, dataImage.disabled)"
                @click="onSelectImage(dataImage)"
                v-if="!isMultiple"
            >
              <template v-if="dataImage.file_type != '3d_model'">
                <img
                     :src="base_url+'/'+dataImage.file_url"
                     :alt="dataImage.file_name"
                     :id="dataImage.id"
                     :height="h"
                     :width="w"
                     :class="`${rootClass}__img`"
                />
                <label :for="dataImage.id" v-if="useLabel" :class="`${rootClass}__lbl`">{{dataImage.file_name}}</label>
              </template>

              <template  v-else >
                <b-icon-file-code width="100" height="100"  />
                <label :for="dataImage.id"  :class="`${rootClass}__lbl`">{{dataImage.file_name}}</label>
              </template>



            </div>

            <div
                :title="assetListItemTitle(dataImage)"
                :class="classThumbnailMultiple(dataImage.id, dataImage.disabled)"
                @click="onSelectMultipleImage(dataImage)"
                v-if="isMultiple"
            >
              <img
                  :src="dataImage.src"
                  :alt="dataImage.alt"
                  :id="dataImage.id"
                  :height="h"
                  :width="w"
                  :class="`${rootClass}__img`"
              />

              <label :for="dataImage.id" v-if="useLabel" :class="`${rootClass}__lbl`">{{dataImage.alt}}</label>
            </div>
          </li>
        </ul>
      </div>
      <hr>
      <b-pagination
          v-model="filePagination.currentPage"
          :total-rows="filePagination.rows"
          :per-page="filePagination.perPage"
          aria-controls="itemList"
          align="right"
          @change="handlePagination"
          v-if="filePagination.total > 0"
      ></b-pagination>

  </div>
</template>

<script>
import Upload from 'vue-material-design-icons/CloudUpload';
export default {
  components:{
    Upload,
  },
  props: {
    dataImages: {
      type: Array,
      default: () => []
    },
    selectedImage: {
      type: Function,
      default: () => { }
    },
    fileType: {
      type: String,
    },
    selectedImages: {
      type: Array,
      default: () => []
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    useLabel: {
      type: Boolean,
      default: false
    },
    rootClass: {
      type: String,
      default: "vue-select-image"
    },
    activeClass: {
      type: String,
      default: "--selected"
    },
    h: {
      type: String,
      default: "auto"
    },
    w: {
      type: String,
      default: "auto"
    },
    limit: {
      type: Number,
      default: 0
    },
    factory_id: {
      type: Number,
      default: 0
    },
    factory:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      default_src: "../assets/images/dummy-t.png",
      file_type: '',
      uploadFile: true,
      file_upload: null,
      filePagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      singleSelected: {
        id: ""
      },
      multipleSelected: [],
      dataImages2: [],
      file_path: '',
      datasource_type: 'color',
      search: '',
      page: '',
      base_url : process.env.VUE_APP_FILE_URL,
    };
  },
  computed: {
    dataImagesLocal: function() {
      return this.dataImages2 || [];
    },
    isSuperAdmin() {
      return this.$store.getters.roleName === 'superadmin'
    }
  },
  async created() {
    let file_type = this.$props.fileType;
    this.datasource_type = file_type.includes('logo') ? 'logo' : file_type;
    let fields = ['base_model', 'texture', 'color', 'sizes', 'font', 'logo','style_icon', '3d_model', '3d_texture', '3d_metalness', '3d_roughness', '3d_ao', '3d_alpha', 'fixed_logo'];
    var exists = fields.some(function(field) {
      return field === file_type
    });
    if(file_type.length > 0 && exists){
      if(file_type == 'base_model'){
        this.file_type = '.jpg, .png';
      }else if(file_type == 'texture'){
        this.file_type = '.svg';
      }else if(file_type == 'color' || file_type.id == 'sizes'){
        this.file_type = '.csv';
      }else if(file_type == 'font'){
        this.file_type = '.woff';
      }else if(file_type == 'logo'){
        this.file_type = '.jpg, .png, .svg';
      }else if(file_type == 'fixed_logo'){
        this.file_type = '.svg';
      }else if(file_type == '3d_model'){
        this.file_type = '.glb, gltf';
      }else if(file_type == '3d_texture' || file_type == '3d_metalness' || file_type == '3d_roughness' || file_type == '3d_ao' || file_type == '3d_alpha'){
        this.file_type = '.png, .jpg, .jpeg, .webp';
      }else if(this.fileType && file_type == 'style_icon'){
        this.file_type = '.jpg, .png';
      }
      try {
        this.$store.commit('set', ['showLoader', true]);
        let file_type_param = file_type == 'fixed_logo' ? 'logo' : file_type;
        let params = '?name=&page=&file_type='+file_type_param+'&asset=1';
        if(this.factory_id > 0){
          params += '&factory_id='+this.factory_id
        }
        let res = await this.$store.dispatch("getFiles", params);
        this.dataImages2 = res.data.data;
        this.file_path = res.storage_path;
        this.filePagination = this.makeFilesPagination(res.data);
        this.$store.commit('set', ['showLoader', false]);
      }catch (err){
        this.showError(err);
      }
    }else {
      this.showToast('You have given wrong file type on component', 'DANGER');
      this.uploadFile = false;
    }

  },
  mounted() {
    // set initial selectedImage
    this.setInitialSelection();
  },
  methods: {
    showAddOnsModal(){
      this.$bvModal.show("assetSelectorModal");
    },
    async addDataSource(e){
      let file = e.target.files[0];
      if (!file) return;
      let ext = '.' + file.name.split('.').pop().toLowerCase();
      let allowedExtensions = this.file_type
        .split(',')
        .map(x => x.trim().toLowerCase());
      if (!allowedExtensions.includes(ext)) {
        this.showToast(`Invalid file type. Allowed: ${this.file_type}`, 'DANGER');
        e.target.value = "";
        return;
      }
      let formData = new FormData();
      formData.append('file', file);
      formData.append('file_type', this.datasource_type);
      formData.append('override', true);
      formData.append('name', file.name);
      formData.append('asset', true);
      formData.append('search', this.search);
      formData.append('page', null);
      formData.append('factory_id', this.factory_id);
      try{
        this.$store.commit('set', ['showLoader', true]);
        let res = await this.$store.dispatch("addDataSource", formData);
        this.$store.commit('set', ['showLoader', false]);
        this.filePagination.rows =this.filePagination.rows + 1;
        this.filePagination.total = this.filePagination.total + 1;
        this.showToast(res.message, 'SUCCESS');
      }catch(err){
        this.$store.commit('set', ['showLoader', false]);
        this.showError(err);
      }

    },
    makeFilesPagination(data){
      this.filePagination.currentPage = data.current_page;
      this.filePagination.rows = data.total;
      this.filePagination.perPage = data.per_page;
      this.filePagination.total = data.total;
      return this.filePagination;
    },
    async searchFiles(search){
      this.search = search
      try {
        this.$store.commit('set', ['showLoader', true]);
        let params = '?name='+this.search+'&page=&file_type='+this.datasource_type+'&asset=1';
        if(this.factory_id > 0){
          params += '&factory_id='+this.factory_id
        }
        let res = await this.$store.dispatch("getFiles", params);
        this.dataImages2 = res.data.data;
        this.file_path = res.storage_path;
        this.filePagination = this.makeFilesPagination(res.data);
        this.$store.commit('set', ['showLoader', false]);
      }catch (err){
        this.showError(err);
      }
    },
    async handlePagination(page){
      this.page = page;
      try {
        this.$store.commit('set', ['showLoader', true]);
        let params = '?name='+this.search+'&page='+this.page+'&file_type='+this.datasource_type+'&asset=1';
        if(this.factory_id > 0){
          params += '&factory_id='+this.factory_id
        }
        let res = await this.$store.dispatch("getFiles", params);
        this.dataImages2 = res.data.data;
        this.file_path = res.storage_path;
        this.filePagination = this.makeFilesPagination(res.data);
        this.$store.commit('set', ['showLoader', false]);
      }catch (err){
        this.showError(err);
      }
    },
    assetListItemTitle(dataImage) {
      if (!dataImage) return ''
      const name = dataImage.file_name || dataImage.alt || ''
      if (!this.isSuperAdmin) {
        return name
      }
      let src = ''
      if (dataImage.sourceable && typeof dataImage.sourceable === 'object' && dataImage.sourceable.name) {
        src = String(dataImage.sourceable.name).trim()
      }
      if (!src) {
        const raw = dataImage.sourceable_name || dataImage.sourceableName || ''
        src = String(raw).trim()
      }
      if (!src || src.toLowerCase() === 'superadmin') {
        return name
      }
      return `${name} — Factory: ${src}`
    },
    classThumbnail(selectedId, imageId, isDisabled) {
      const baseClass = `${this.rootClass}__thumbnail`;
      if (isDisabled) {
        return `${baseClass} ${baseClass}--disabled`;
      }
      if (selectedId === imageId) {
        return `${baseClass} ${baseClass}${this.activeClass}`;
      }
      return `${baseClass}`;
    },
    classThumbnailMultiple(id, isDisabled) {
      const baseClass = `${this.rootClass}__thumbnail`;
      const baseMultipleClass = `${baseClass} is--multiple`;
      if (isDisabled) {
        return `${baseMultipleClass} ${baseClass}--disabled`;
      }
      if (this.isExistInArray(id)) {
        return `${baseMultipleClass} ${baseClass}${this.activeClass}`;
      }
      return `${baseMultipleClass}`;
    },
    onSelectImage(objectImage) {
      if (!objectImage.disabled) {
        this.singleSelected = Object.assign({}, this.singleSelected, objectImage);
        this.$emit("onselectimage", objectImage);
        this.selectedImage(this.singleSelected);
      }
    },
    isExistInArray(id) {
      return this.multipleSelected.find(item => {
        return id === item.id;
      });
    },
    removeFromSingleSelected() {
      this.singleSelected = {};
      this.$emit("onselectimage", {});
    },
    removeFromMultipleSelected(id, dontFireEmit) {
      this.multipleSelected = this.multipleSelected.filter(item => {
        return id !== item.id;
      });
      if (!dontFireEmit) {
        this.$emit("onselectmultipleimage", this.multipleSelected);
      }
    },
    resetMultipleSelection() {
      this.multipleSelected = [];
    },
    onSelectMultipleImage(objectImage) {
      if (!objectImage.disabled) {
        if (!this.isExistInArray(objectImage.id)) {
          if (this.limit > 0) {
            if (this.multipleSelected.length < this.limit) {
              this.multipleSelected.push(objectImage);
              this.$emit("onselectmultipleimage", this.multipleSelected);
            } else {
              this.$emit("onreachlimit", this.limit);
            }
          } else {
            this.multipleSelected.push(objectImage);
            this.$emit("onselectmultipleimage", this.multipleSelected);
          }
        } else {
          this.removeFromMultipleSelected(objectImage.id, true);
          this.$emit("onselectmultipleimage", this.multipleSelected);
        }
      }
    },
    setInitialSelection() {
      if (this.selectedImages) {
        if (!this.isMultiple && this.selectedImages.length === 1) {
          this.singleSelected = Object.assign({}, this.selectedImages[0]);
        } else {
          this.multipleSelected = [].concat(this.selectedImages);
        }
      }
    }
  }
};
</script>

<style src="./vue-select-image.css"></style>